module.exports = __webpack_public_path__ + "img/menu_icon_ltr.9cc1a2a.svg";